import _ from 'lodash';
import {persurlToStringFormat} from 'model/PersurlUtil';
import {confirmJN} from 'module/ConfirmDialog/component/ConfirmDialogContainer';

export function showDeleteConfirm(model, additionalInfo) {
	let message;
	switch (model.sisName || model.getSisName()) {
		case "booking":
			message = "Möchten Sie die Buchung wirklich löschen? ";
			break;
		case 'persurl':
			message = 'Möchten Sie die ganztägige Abwesenheit wirklich löschen? ';
			break;
		default:
			message = 'Möchten Sie den Eintrag wirklich löschen? ';
			break;
	}
	if (typeof additionalInfo == 'string') message += additionalInfo;

	return confirmJN("Löschen", message)
}

// predefined error messages
/**
 *
 * @param arrayOfModels array of objects, that have the method toStringFormat for serialisation
 * @returns {$.Deferred}
 */
export function showPersurlCollisionMessage(arrayOfModels) {
	let msg = "Bei dieser Aktion werden existierende ganztägige Abwesenheiten überschrieben";
	if (!arrayOfModels || !arrayOfModels.length) msg += ".";
	else {
		msg += ":\n";
		msg += _.map(arrayOfModels, m => persurlToStringFormat(m)).join('\n');
	}
	return confirmJN("Überschneidung", msg);
}